var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCollapse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 21 21"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  rx: 4,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 3,
  d: "M16.482 10.305H4.128"
})));
export { SvgCollapse as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 21 21'%3e %3crect width='21' height='21' rx='4' fill='currentColor'/%3e %3cg transform='translate(3.128 3.128)'%3e %3cg%3e %3cline y2='12.354' transform='translate(13.354 7.177) rotate(90)' fill='none' stroke='%23fff' stroke-width='3'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";